import LocalStorageService from "../services/localStorage";
import { Steps } from "../enum/steps";
var storageKey = "afy-steps";
var localStorageService = new LocalStorageService(storageKey);
export var removeNonNumeric = function (value) {
    if (value) {
        return value.replace(/\D/g, "");
    }
};
export var formatDocument = function (value) {
    if (value) {
        var result = value;
        //let nameType = type.replace(/é/g, "e").toLowerCase()
        if (value.length === 11) {
            result = "".concat(value.slice(0, 3), "-").concat(value.slice(3, 10), "-").concat(value.slice(10));
        }
        return result;
    }
};
export var filterData = function (array, key, value) {
    var temp = [];
    temp = array.filter(function (e) {
        return e[key] == value;
    });
    var result = [];
    temp.map(function (item, idx) {
        result.push({ id: item.id, name: item.description, value: item.code });
    });
    return result;
};
export var transformToSelect = function (array) {
    var result = [];
    if (array)
        if (array.length > 0)
            array.map(function (item) {
                result.push({
                    id: item.id,
                    value: item.id,
                    name: item.name,
                    default: item.default ? item.default : false,
                });
            });
    return result;
};
export var setCampaignData = function (event) {
    var cdata = [];
    cdata = localStorageService.getStepStored().steps[Steps.plan].campaign;
    var data = localStorageService.getStepStored().steps[Steps.plan];
    var selected;
    if (cdata)
        cdata.map(function (item) {
            if (item.id === event) {
                item.default = true;
                selected = item;
            }
            else {
                item.default = false;
            }
        });
    // localStorageService.setStepStored({
    //   id: data.id,
    //   name: data.name as string,
    //   step: data.step,
    //   completed: data.completed,
    //   campaign: cdata,
    //   campaignSelected: selected ? selected : data.campaignSelected,
    // });
};
export var setPaymentModeData = function (event, paymentMode) {
    var cdata = [];
    cdata = paymentMode;
    var data = localStorageService.getStepStored().steps[Steps.plan];
    var selected;
    if (event == null) {
        console.log("Payment mode null, hence first element is selected", paymentMode[0]);
        selected = paymentMode[0];
    }
    else {
        if (cdata)
            cdata.map(function (item) {
                if (item.id === event) {
                    item.default = true;
                    selected = item;
                }
                else {
                    item.default = false;
                }
            });
    }
    // localStorageService.setStepStored({
    //   id: data.id,
    //   name: data.name as string,
    //   step: data.step,
    //   completed: data.completed,
    //   campaign: data.campaign,
    //   campaignSelected: data.campaignSelected,
    //   paymentMode: cdata,
    //   paymentModeSelected: selected ? selected : data.paymentModeSelected,
    //   quoteId: data.quoteId,
    //   policyId: data.policyId,
    // });
    return cdata;
};
export var getInfo = function (key, stepName) {
    if (!key)
        return null;
    var storedData = localStorage.getItem(key);
    if (storedData) {
        try {
            var parsedData = JSON.parse(storedData);
            // If stepName parameter is provided, filter by step
            if (stepName) {
                // If parsedData is an array (like steps.json), filter by step property
                if (Array.isArray(parsedData)) {
                    return parsedData.find(function (item) { return item.step === stepName; }) || null;
                }
                // If parsedData has a steps property that's an array
                if (parsedData.steps && Array.isArray(parsedData.steps)) {
                    return (parsedData.steps.find(function (item) { return item.step === stepName; }) || null);
                }
            }
            return parsedData;
        }
        catch (_a) {
            return null;
        }
    }
    return null;
};
export var getLogin = function () {
    var result = localStorage.getItem("assurehub");
    if (result) {
        try {
            return JSON.parse(result);
        }
        catch (_a) {
            return null;
        }
    }
    return null;
};
export var getVariables = function () {
    var result = localStorage.getItem("afy-variables");
    if (result) {
        try {
            return JSON.parse(result);
        }
        catch (_a) {
            return null;
        }
    }
    return null;
};
export var getYearFromDate = function (dateString) {
    if (!dateString)
        return null;
    var date = new Date(dateString);
    if (isNaN(date.getTime()))
        return null;
    return date.getUTCFullYear();
};
